<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card no-body class="costs-configuration-card">
        <b-tabs v-model="tabIndex" active-nav-item-class="font-weight-bold text-uppercase text-dark">

          <b-tab>
            <template #title><AppIcon name="currency-dollar" class="mr-1" /> Precios</template>
            <div class="costs-configuration-tab">

              <div class="app-alert app-alert--warning" v-if="!parameters.roundUp">
                <span class="app-alert__icon"><AppIcon name="warning" /></span>
                <div class="app-alert__content">
                  El redondeo de precios no está habilitado para este módulo.
                  Para activarlo, habilitá el parámetro correspondiente desde la administración del sistema.
                </div>
              </div>

              <template v-if="parameters.roundUp">
                <b-row v-if="crud.form['ID1']">
                  <b-col md="4" sm="12">
                    <b-form-group
                      label="Múltiplo para el redondeo de precios de venta"
                      description="Define el múltiplo al que se redondean hacia arriba los precios finales de venta. Con 0 solo se eliminan los decimales. Ej: con base 500, un precio de $15.200 pasa a $15.500."
                    >
                      <b-form-select
                        v-model="crud.form.ID1.value_number"
                        :options="crud.form.ID1.value_number_opt"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <div class="costs-configuration-actions">
                  <b-button variant="primary" size="sm" @click="savePrecios()">
                    <AppIcon name="save" class="mr-1" />Guardar
                  </b-button>
                </div>
              </template>
            </div>
          </b-tab>

        </b-tabs>
      </b-card>

      <b-card body-class="py-2">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },

    data: () => {
      return {
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'configuration',
          elements: {}
        },
        parameters: {
          roundUp: Helper.hasParametersAccess(Param.P69),
        },
        crud: {
          form: {
            ID1: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
              value_number_opt: [
                { value: 0,    text: 'Sin múltiplo (elimina decimales)' },
                { value: 10,   text: '10' },
                { value: 50,   text: '50' },
                { value: 100,  text: '100' },
                { value: 500,  text: '500' },
                { value: 1000, text: '1.000' },
                { value: 5000, text: '5.000' },
              ]
            },
          },
        },
        tabIndex: 0,
      }
    },

    created () {
      Helper.hasAccessView(this.access)
    },

    mounted () {
      this.show()
    },

    methods: {
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      show() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data

          data.forEach(element => {
            if (element.id == 1) {
              this.crud.form.ID1.id = element.id
              this.crud.form.ID1.value_number = parseInt(element.value_number)
            }
          })
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },

      savePrecios() {
        this.confirmDialog('¿Guardar configuración?', {
          title: 'Guardar Configuración',
          icon: 'save',
          okTitle: 'GUARDAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show()

            var result = serviceAPI.saveConfiguracion(this.crud.form.ID1)

            result.then((response) => {
              loader.hide()
              this.show()
              this.$awn.success("Configuración guardada")
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
    }
  }
</script>

<style scoped>
  .costs-configuration-card {
    overflow: hidden;
  }
  .costs-configuration-card ::v-deep .nav-tabs {
    background: var(--app-color-surface);
    border-bottom: 1px solid var(--app-color-border);
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 8px 10px 0;
  }
  .costs-configuration-card ::v-deep .nav-link {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-size: var(--app-text-sm);
    gap: 4px;
    white-space: nowrap;
  }
  .costs-configuration-card ::v-deep .nav-link.active {
    background: var(--app-color-surface);
    border-color: var(--app-color-border) var(--app-color-border) var(--app-color-surface);
    color: var(--app-color-text);
  }
  .costs-configuration-tab {
    padding: 16px;
  }
  .costs-configuration-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
  }
  @media (max-width: 767.98px) {
    .costs-configuration-tab {
      padding: 12px;
    }
    .costs-configuration-actions .btn {
      justify-content: center;
      width: 100%;
    }
  }
</style>
